export default __webpack_public_path__ + "static/media/605.3c7f59a4.gif";